export default __webpack_public_path__ + "static/media/PromoBg@2x.ef5774525bbff1384f73dba3c9540943.png";